module.exports = __webpack_public_path__ + "img/lc.d34dd4b4.svg";